import { z } from 'zod';

export const InvestmentAccountPropsSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  type: z.string().min(1, 'Type is required'),
  status: z.string().min(1, 'Status is required'),
});

export type InvestmentAccountProps = z.infer<typeof InvestmentAccountPropsSchema>;
